<template>
  <div class="home-page">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container">
        <div class="nav-brand">
          <img :src="icon_logo" alt="嗨圈" class="logo" />
          <span class="brand-text">嗨圈</span>
        </div>
        <!-- 桌面端导航菜单 -->
        <nav class="nav-menu desktop-menu">
          <a href="#hero" class="nav-item" @click="scrollToAnchor('hero')"
            >首页</a
          >
          <!-- <a
            href="#recharge"
            class="nav-item"
            @click="scrollToAnchor('recharge')"
            >充值</a
          > -->
          <div
            class="nav-dropdown"
            @mouseenter="showDropdown"
            @mouseleave="hideDropdown"
          >
            <a href="#" class="nav-item">入驻合作 ▼</a>
            <div class="dropdown-menu" :class="{ show: dropdownVisible }">
              <a
                href="#partner"
                class="dropdown-item"
                @click="navigateToPartnerPage(1)"
                >达人入驻</a
              >
              <a
                href="#partner"
                class="dropdown-item"
                @click="navigateToPartnerPage(0)"
                >渠道入驻</a
              >
            </div>
          </div>
          <a href="#about" class="nav-item" @click="scrollToAnchor('about')"
            >关于我们</a
          >
        </nav>
        <!-- 移动端汉堡菜单按钮 -->
        <button class="mobile-menu-btn" @click="toggleMobileMenu">
          <span class="hamburger-line"></span>
          <span class="hamburger-line"></span>
          <span class="hamburger-line"></span>
        </button>
        <a href="#footer" class="nav-actions" @click="scrollToAnchor('footer')"
          >下载申请</a
        >
      </div>
      <!-- 移动端导航菜单 -->
      <nav class="mobile-nav" :class="{ active: mobileMenuOpen }">
        <a href="#hero" class="mobile-nav-item" @click="closeMobileMenu('hero')"
          >首页</a
        >
        <a
          href="#recharge"
          class="mobile-nav-item"
          @click="closeMobileMenu('recharge')"
          >充值</a
        >
        <div class="mobile-dropdown">
          <button class="mobile-dropdown-btn" @click="toggleMobileDropdown">
            入驻合作
            <span class="dropdown-arrow" :class="{ open: mobileDropdownOpen }"
              >▼</span
            >
          </button>
          <div
            class="mobile-dropdown-content"
            :class="{ show: mobileDropdownOpen }"
          >
            <a
              href="#partner"
              class="mobile-dropdown-item"
              @click="navigateToPartnerPageMobile(1)"
              >达人入驻</a
            >
            <a
              href="#partner"
              class="mobile-dropdown-item"
              @click="navigateToPartnerPageMobile(0)"
              >渠道入驻</a
            >
          </div>
        </div>
        <a
          href="#about"
          class="mobile-nav-item"
          @click="closeMobileMenu('about')"
          >关于我们</a
        >
      </nav>
    </header>

    <!-- 主要内容区域 -->
    <main>
      <!-- 应用展示区域 -->
      <section id="hero" class="hero-section">
        <div class="container">
          <div class="hero-content">
            <div>
              <div class="hero-title">嗨圈,找到你感兴趣的圈子~</div>
              <div class="hero-subtitle">
                在这里，遇见同好，分享生活，玩转兴趣
              </div>
            </div>
            <div class="phone-mockups">
              <!-- 桌面端瀑布流布局 -->
              <div class="phone-group desktop-phone-group">
                <img
                  :src="icon_phone1"
                  alt="手机界面1"
                  class="phone-image"
                  @mouseenter="handlePhoneHover($event, true)"
                  @mouseleave="handlePhoneHover($event, false)"
                />
                <img
                  :src="icon_phone2"
                  alt="手机界面2"
                  class="phone-image phone-imageTwo"
                  @mouseenter="handlePhoneHover($event, true)"
                  @mouseleave="handlePhoneHover($event, false)"
                />
                <img
                  :src="icon_phone3"
                  alt="手机界面3"
                  class="phone-image phone-imageThree"
                  @mouseenter="handlePhoneHover($event, true)"
                  @mouseleave="handlePhoneHover($event, false)"
                />
                <img
                  :src="icon_phone4"
                  alt="手机界面4"
                  class="phone-image phone-imageFour"
                  @mouseenter="handlePhoneHover($event, true)"
                  @mouseleave="handlePhoneHover($event, false)"
                />
                <img
                  :src="icon_phone5"
                  alt="手机界面5"
                  class="phone-image phone-imageFive"
                  @mouseenter="handlePhoneHover($event, true)"
                  @mouseleave="handlePhoneHover($event, false)"
                />
              </div>

              <!-- 移动端轮播布局 -->
              <div class="phone-carousel mobile-phone-carousel">
                <div class="phone-carousel-container">
                  <div
                    class="phone-carousel-wrapper"
                    :style="{
                      transform: `translateX(${20 - currentPhoneSlide * 60}%)`,
                    }"
                    @touchstart="handleTouchStart"
                    @touchmove="handleTouchMove"
                    @touchend="handleTouchEnd"
                  >
                    <div
                      v-for="(phoneImage, index) in phoneImages"
                      :key="index"
                      class="phone-carousel-slide"
                      :class="{ 'active-slide': index === currentPhoneSlide }"
                    >
                      <img
                        :src="phoneImage.src"
                        :alt="phoneImage.alt"
                        class="phone-image-carousel"
                        :class="{ 'active-image': index === currentPhoneSlide }"
                      />
                    </div>
                  </div>
                </div>
                <!-- 轮播指示器 -->
                <div class="phone-carousel-indicators">
                  <button
                    v-for="(phoneImage, index) in phoneImages"
                    :key="index"
                    class="phone-indicator"
                    :class="{ active: currentPhoneSlide === index }"
                    @click="goToPhoneSlide(index)"
                  ></button>
                </div>
              </div>
            </div>

            <div class="download-buttons">
              <!-- H5 -->
              <div
                class="download-btn apple"
                @mouseenter="showQRCode('apple')"
                @mouseleave="hideQRCode('apple')"
                @click="goToMobileWeb"
              >
                <div class="btn-content">
                  <img
                    class="btn-content-left"
                    :src="icon_fruitB"
                    alt="Apple QR Code"
                  />
                  <div class="btn-content-right">
                    <span class="btn-text-large">手机网页版</span>
                  </div>
                </div>
              </div>
              <!-- Apple -->
              <!-- <div
                class="download-btn apple"
                @mouseenter="showQRCode('apple')"
                @mouseleave="hideQRCode('apple')"
              >
                <div class="btn-content">
                  <img
                    class="btn-content-left"
                    :src="icon_ios"
                    alt="Apple QR Code"
                  />
                  <div class="btn-content-right">
                    <span class="btn-text-large">App Store</span>
                  </div>
                </div>
                <div class="qr-popup" :class="{ show: qrCodeVisible.apple }">
                  <div class="qr-code">
                    <img
                      :src="ios_url"
                      alt="Apple QR Code"
                    />
                  </div>
                  <div class="qr-text">扫码下载 App Store 版本</div>
                </div>
              </div> -->
              <!-- Android -->
              <div
                class="download-btn android"
                @mouseenter="showQRCode('android')"
                @mouseleave="hideQRCode('android')"
                @click="handleDownloadClick('android')"
              >
                <div class="btn-content">
                  <img
                    class="btn-content-left"
                    :src="icon_android"
                    alt="Android QR Code"
                  />
                  <div class="btn-content-right">
                    <span class="btn-text-large">Android</span>
                  </div>
                </div>
                <div class="qr-popup" :class="{ show: qrCodeVisible.android }">
                  <div class="qr-code">
                    <img :src="androidQrCode" alt="Android QR Code" />
                  </div>
                  <div class="qr-text" @click="clickToDownload('android')">
                    点我下载
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 嗨果充值区域---暂时隐藏 -->
      <section v-if="false" id="recharge" class="recharge-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">
              <img :src="icon_fruit" alt="嗨果" class="title-icon" />
              嗨果充值
            </h2>
            <div v-if="userInfo.id == ''" class="search-container">
              <div class="search-box">
                <img :src="icon_search" alt="搜索" class="search-icon" />
                <input
                  v-model="searchQuery"
                  type="text"
                  class="search-input"
                  placeholder="搜索嗨圈手机号"
                  @keyup.enter="handleSearch"
                />
                <button class="search-btn" @click="handleSearch">搜索</button>
              </div>
            </div>
            <div v-else class="user-info-card">
              <div class="user-avatar">
                <img :src="userInfo.avatar || icon_avatar" alt="用户头像" />
              </div>
              <div class="user-details">
                <div class="user-info-row">
                  <span class="user-nickname"
                    >昵称: {{ userInfo.name || "路人甲" }}</span
                  >
                  <span class="user-id"
                    >ID: {{ userInfo.id || "3423214" }}</span
                  >
                </div>
                <div class="user-info-rowT" @click="resetUserInfo">切换</div>
              </div>
            </div>
          </div>

          <div class="recharge-tabs">
            <button
              class="tab-btn"
              :class="{ active: activeTab === 'digital' }"
              @click="switchTab('digital')"
            >
              官方数额
            </button>
            <button
              class="tab-btn"
              :class="{ active: activeTab === 'other' }"
              @click="switchTab('other')"
            >
              指定数额
            </button>
          </div>

          <div v-if="activeTab === 'digital'" class="price-grid">
            <div
              v-for="(item, index) in packageList"
              :key="item.id"
              class="price-card"
              :class="{
                featured: selectedIndex === index,
              }"
              @click="selectPrice(item, index)"
            >
              <div v-if="item.remark == 1" class="hot-label">首冲推荐</div>
              <div class="price-badge">
                <img
                  v-if="selectedIndex === index"
                  :src="icon_fruitB"
                  class="price-badge-icon"
                />
                <img v-else :src="icon_fruit" class="price-badge-icon" />

                {{ item.rechargeAmount }}
              </div>
              <div class="price-amount">￥{{ item.rechargeAmount }}</div>
            </div>
          </div>
          <div v-else class="custom-amount-section">
            <div class="custom-amount-input-container">
              <img :src="icon_fruit" alt="嗨果" class="custom-amount-icon" />
              <input
                v-model="customAmount"
                type="number"
                class="custom-amount-input"
                placeholder="输入指定数额[18元起充]"
                min="1"
                @input="handleCustomAmountChange"
              />
            </div>
          </div>

          <div class="payment-section">
            <div class="payment-left">
              <h3 class="payment-title">支付方式</h3>
              <div class="payment-methods">
                <button
                  v-for="(mode, index) in payModeList"
                  :key="index"
                  class="payment-btn"
                  :class="{ active: payModeIndex === index }"
                  @click="selectPaymentMode(index)"
                >
                  {{ mode }}
                </button>
              </div>
              <p class="payment-notice">
                未成年人及其监护人，请务必阅读此健康提醒，谨慎充值
              </p>
            </div>

            <div class="amount-row">
              <div class="amount-info">
                <div class="amount-label">
                  <span>应付金额:</span>
                  <span
                    style="margin: 0 8px; color: #efa536; font-size: 28px"
                    >{{ selectedPrice }}</span
                  >
                  <span>元</span>
                </div>
                <div class="amount-description">
                  <span>充值即代表您同意</span>
                  <span style="color: #efa536" @click="showAgreementClick"
                    >《嗨圈充值协议》</span
                  >
                </div>
              </div>
              <button class="confirm-btn" @click="confirmRecharge">
                确认充值
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- 成为渠道伙伴区域 -->
      <section id="partner" class="partner-section">
        <div class="carousel-container">
          <!-- 轮播图滑动容器 -->
          <div
            class="carousel-wrapper"
            :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
          >
            <div
              v-for="(slide, slideIndex) in NewPartnerSlides"
              :key="slideIndex"
              class="carousel-slide"
            >
              <div class="container">
                <div class="partner-title">{{ slide.title }}</div>
                <div class="partner-content">
                  <div class="partner-left">
                    <div class="partner-subtitle">{{ slide.subtitle }}</div>
                    <div class="partner-nav">
                      <a
                        v-for="category in slide.categories"
                        :key="category"
                        href="#"
                        class="partner-nav-item"
                        :class="{ active: slide.activeCategory === category }"
                        @click.prevent="
                          switchSlideCategory(slideIndex, category)
                        "
                      >
                        {{ category }}
                      </a>
                    </div>
                  </div>
                  <div class="partner-right">
                    <div
                      class="partner-features"
                      :class="`feature-type-${slide.getCurrentFeatures().type}`"
                    >
                      <!-- Type 0: 简单列表样式 -->
                      <template v-if="slide.getCurrentFeatures().type === 0">
                        <div
                          v-if="slide.getCurrentFeatures().Ctitle"
                          class="feature-custom-title"
                        >
                          {{ slide.getCurrentFeatures().Ctitle }}
                        </div>
                        <div
                          v-for="(feature, index) in slide.getCurrentFeatures()
                            .content"
                          :key="index"
                          class="feature-item feature-item-type-0"
                        >
                          <img
                            v-if="index == 0"
                            :src="icon_one"
                            alt="功能图标"
                            class="feature-item-icon"
                          />
                          <img
                            v-if="index == 1"
                            :src="icon_two"
                            alt="功能图标"
                            class="feature-item-icon"
                          />
                          <img
                            v-if="index == 2"
                            :src="icon_three"
                            alt="功能图标"
                            class="feature-item-icon"
                          />
                          <img
                            v-if="index == 3"
                            :src="icon_four"
                            alt="功能图标"
                            class="feature-item-icon"
                          />
                          <span class="feature-text">{{ feature }}</span>
                        </div>
                      </template>

                      <!-- Type 1: 复杂卡片样式 -->
                      <template v-if="slide.getCurrentFeatures().type === 1">
                        <div
                          v-if="slide.getCurrentFeatures().Ctitle"
                          class="feature-custom-title"
                        >
                          {{ slide.getCurrentFeatures().Ctitle }}
                        </div>
                        <div
                          v-for="(feature, index) in slide.getCurrentFeatures()
                            .content"
                          :key="index"
                          class="feature-item feature-item-type-1"
                          :class="{
                            'has-divider':
                              index <
                              slide.getCurrentFeatures().content.length - 1,
                          }"
                        >
                          <div class="feature-card-title">
                            {{ feature.title }}
                          </div>
                          <div class="feature-card-content">
                            {{ feature.content }}
                          </div>
                        </div>
                      </template>

                      <!-- Type 2: 流程步骤样式 -->
                      <template v-if="slide.getCurrentFeatures().type === 2">
                        <div
                          v-if="slide.getCurrentFeatures().Ctitle"
                          class="feature-custom-title"
                        >
                          {{ slide.getCurrentFeatures().Ctitle }}
                        </div>
                        <div
                          v-for="(feature, index) in slide.getCurrentFeatures()
                            .content"
                          :key="index"
                          class="feature-item feature-item-type-2"
                        >
                          <img
                            v-if="index == 0"
                            :src="icon_one"
                            alt="功能图标"
                            class="feature-item-icon"
                          />
                          <img
                            v-if="index == 1"
                            :src="icon_two"
                            alt="功能图标"
                            class="feature-item-icon"
                          />
                          <img
                            v-if="index == 2"
                            :src="icon_three"
                            alt="功能图标"
                            class="feature-item-icon"
                          />
                          <img
                            v-if="index == 3"
                            :src="icon_four"
                            alt="功能图标"
                            class="feature-item-icon"
                          />
                          <span class="feature-text">{{ feature }}</span>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 轮播图控制按钮 -->
          <div class="carousel-controls">
            <button
              class="carousel-btn prev-btn"
              @click="prevSlide"
              :disabled="currentSlide === 0"
            >
              <img :src="icon_cut" alt="上一张" class="btn-icon prev-icon" />
            </button>
            <button
              class="carousel-btn next-btn"
              @click="nextSlide"
              :disabled="currentSlide === NewPartnerSlides.length - 1"
            >
              <img :src="icon_cut" alt="下一张" class="btn-icon next-icon" />
            </button>
          </div>

          <!-- 轮播图指示器 -->
          <div class="carousel-indicators">
            <button
              v-for="(slide, index) in NewPartnerSlides"
              :key="index"
              class="indicator"
              :class="{ active: currentSlide === index }"
              @click="goToSlide(index)"
            ></button>
          </div>
        </div>
      </section>

      <!-- 关于我们区域 -->
      <section id="about" class="about-section">
        <!-- 装饰气泡 -->
        <div class="bubble bubble-top-left"></div>
        <div class="bubble bubble-bottom-right"></div>

        <div class="container">
          <div class="section-title">
            <div>关于我们</div>
            <img :src="icon_exclaim" alt="三个点" class="title-exclaim" />
          </div>
          <p class="about-text">
            嗨圈是一个创新的内容分享平台，致力于为用户提供一个情绪治愈的温馨环境。在这里，你可以分享真实的生活点滴，抒发心情，获得情感上的支持与共鸣。通过精心的内容推荐，嗨圈帮助你发现更多有趣的内容，打造一个纯粹的分享空间。不论是开心的瞬间，还是低落的时刻，都能在这里找到共鸣，释放压力，获得内心的平静与愉悦。加入嗨圈，开启你的情感治愈之旅，让每一段分享都温暖而真实。
          </p>
          <p class="about-text">公司：沈阳嗨圈科技有限公司</p>
          <p class="about-text-t">
            地点：辽宁省沈阳市浑南区世纪路2号5号楼2003B室
          </p>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <footer id="footer" class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-contact">
            <span>官方微信</span>
            <img src="@/assets/icon_kf.png" alt="客服图标" />
          </div>
          <div class="footer-downloads">
            <!-- H5 -->
            <div
              class="footer-download-btn ios"
              @mouseenter="showQRCode('footer_apple')"
              @mouseleave="hideQRCode('footer_apple')"
              @click="goToMobileWeb"
            >
              <div class="btn-content">
                <img
                  class="btn-content-left"
                  :src="icon_fruit"
                  alt="Apple QR Code"
                />
                <div class="btn-content-right">
                  <span class="btn-text-large">手机网页版</span>
                </div>
              </div>
            </div>
            <!-- Apple -->
            <!-- <div
              class="footer-download-btn ios"
              @mouseenter="showQRCode('footer_apple')"
              @mouseleave="hideQRCode('footer_apple')"
            >
              <div class="btn-content">
                <img
                  class="btn-content-left"
                  :src="icon_iosB"
                  alt="Apple QR Code"
                />
                <div class="btn-content-right">
                  <span class="btn-text-large">App Store</span>
                </div>
              </div>
              <div
                class="qr-popup footer-qr-popup"
                :class="{ show: qrCodeVisible.footer_apple }"
              >
                <div class="qr-code">
                  <img
                    :src="ios_url"
                    alt="Apple QR Code"
                  />
                </div>
                <div class="qr-text">扫码下载 App Store 版本</div>
              </div>
            </div> -->
            <!-- Android -->
            <div
              class="footer-download-btn android"
              @mouseenter="showQRCode('footer_android')"
              @mouseleave="hideQRCode('footer_android')"
              @click="handleDownloadClick('android')"
            >
              <div class="btn-content">
                <img
                  class="btn-content-left"
                  :src="icon_androidB"
                  alt="Android QR Code"
                />
                <div class="btn-content-right">
                  <span class="btn-text-large">Android</span>
                </div>
              </div>
              <div
                class="qr-popup footer-qr-popup"
                :class="{ show: qrCodeVisible.footer_android }"
              >
                <div class="qr-code">
                  <img :src="androidQrCode" alt="Android QR Code" />
                </div>
                <div class="qr-text" @click="clickToDownload('android')">
                  扫码下载 Android 版本
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <!-- 充值支付弹窗 -->
    <el-dialog
      :title="PayTitle"
      :visible.sync="rechargeShow"
      width="400px"
      :close-on-click-modal="true"
      center
      @close="hideRechargeModal"
    >
      <div class="qr-code-container">
        <img :src="rechargeQrCode" alt="支付二维码" class="qr-code-image" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideRechargeModal">取 消</el-button>
        <el-button type="primary" @click="confirmPaymentSFTSmartpay"
          >我已支付</el-button
        >
      </span>
    </el-dialog>

    <!-- 协议弹窗 -->
    <el-dialog
      title="嗨圈充值协议"
      :visible.sync="showAgreement"
      width="600px"
      :close-on-click-modal="true"
      center
      @close="hideAgreementModal"
      class="agreement-dialog"
    >
      <div class="agreement-content" v-loading="agreementLoading">
        <div v-if="agreementContent" v-html="agreementContent"></div>
        <div v-else-if="!agreementLoading" class="no-content">暂无协议内容</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showAgreement = false"
          >我知道了</el-button
        >
      </span>
    </el-dialog>

    <!-- 下载模态框 -->
    <div
      v-if="downloadModalVisible"
      class="download-modal"
      @click="hideDownloadModal"
    >
      <div class="modal-content" @click.stop>
        <h3>下载 {{ downloadPlatform }} 应用</h3>
        <p>
          即将跳转到{{
            downloadPlatform === "iOS" ? "App Store" : "Google Play"
          }}进行下载
        </p>
        <div class="modal-buttons">
          <button class="cancel-btn" @click="hideDownloadModal">取消</button>
          <button class="confirm-btn" @click="confirmDownload">确认下载</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getHiUser,
  findRecharge,
  payAlipayUrl,
  paySFTUrl,
  paySmartpayUrl,
  userRecharge,
  findHiAgreement,
  getDict,
} from "@/config/api";
import {
  getCurrentDateTime,
  generateOrderNo,
  getPayUrlSFT,
  getPayUrlSmartpay,
} from "@/utils/paymentUtils";
import QRCode from "qrcode";
export default {
  name: "HomePage",
  data() {
    return {
      icon_logo: require("@/assets/icon_logo.png"),
      icon_phone1: require("@/assets/icon_phone1.png"),
      icon_phone2: require("@/assets/icon_phone2.png"),
      icon_phone3: require("@/assets/icon_phone3.png"),
      icon_phone4: require("@/assets/icon_phone4.png"),
      icon_phone5: require("@/assets/icon_phone5.png"),
      icon_ios: require("@/assets/icon_ios.png"),
      icon_iosB: require("@/assets/icon_iosB.png"),
      icon_android: require("@/assets/icon_android.png"),
      icon_androidB: require("@/assets/icon_androidB.png"),
      icon_fruit: require("@/assets/icon_fruit.png"),
      icon_fruitB: require("@/assets/icon_fruitB.png"),
      icon_search: require("@/assets/icon_search.png"),
      icon_avatar: require("@/assets/icon_fruit.png"),
      icon_exclaim: require("@/assets/exclaim.png"),
      icon_cut: require("@/assets/cut.png"),
      icon_one: require("@/assets/icon_one.png"),
      icon_two: require("@/assets/icon_two.png"),
      icon_three: require("@/assets/icon_three.png"),
      icon_four: require("@/assets/icon_four.png"),
      /**H5地址 */
      H5_url: "http://mp.haiquan.fun",
      /**苹果下载二维码 */
      ios_url: "",
      /**安卓下载二维码 */
      android_url:
        "https://www.pgyer.com/haiquan-android",
      /**安卓二维码图片 */
      androidQrCode: "",
      // 充值标签页
      activeTab: "digital",
      // 价格列表
      packageList: [],
      selectedIndex: null,
      // 选中的价格
      selectedPrice: 0,
      // 搜索查询
      searchQuery: "",
      // 搜索用户数据
      userInfo: {
        id: "",
        name: "",
        avatar: "",
      },
      /**支付弹窗标题 */
      PayTitle: "",
      /**支付方式列表 */
      // payModeList: ["微信支付", "支付宝支付"],
      payModeList: [],
      /**选中支付方式下标 */
      payModeIndex: 0,
      // 自定义充值金额
      customAmount: "",
      // 下单充值二维码
      rechargeQrCode: "",
      // 下单充值弹窗
      rechargeShow: false,
      // 下单订单
      rechargeOrder: {},
      // 轮播图相关
      currentSlide: 0,
      /**协议弹窗 */
      showAgreement: false,
      /**协议内容 */
      agreementContent: "",
      /**协议加载状态 */
      agreementLoading: false,
      partnerSlides: [
        {
          title: "成为渠道伙伴  学习变现思维",
          subtitle: "成为渠道合作伙伴",
          activeCategory: "适合谁加入？",
          categories: ["适合谁加入？", "申请优势", "合作流程"],
          featuresData: {
            "适合谁加入？": [
              "想拓展变现渠道的自媒体创业者，让 “内容影响力” 叠加 “渠道运营力”",
              "有博主资源积累的中间人，把人脉变成可持续收益的 “管道”",
              "想探索副业增收的自由职业者，用灵活合作模式适配多元生活节奏",
              "尝试团队新业务的中小机构，以轻资产模式测试内容变现可能性",
            ],
            申请优势: [
              "专业团队为您提供内容创作服务，确保作品质量和影响力",
              "多平台同步发布，最大化您的内容覆盖面和曝光率",
              "数据分析和优化建议，帮助您提升内容表现",
              "24小时客服支持，随时解决您的疑问和需求",
            ],
            合作流程: [
              "详细的合作流程说明和操作指南",
              "丰富的营销素材和推广工具包",
              "定期的培训课程和经验分享会",
              "专属的合作伙伴支持团队和沟通渠道",
            ],
          },
          get currentFeatures() {
            return (
              this.featuresData[this.activeCategory] ||
              this.featuresData["快速盈利模式"]
            );
          },
        },
        {
          title: "企业级合作 打造品牌优势",
          subtitle: "企业级合作",
          activeCategory: "品牌合作",
          categories: ["品牌合作", "市场推广", "数据分析"],
          featuresData: {
            品牌合作: [
              "深度合作，打造双赢局面，共同推动业务增长",
              "专业的品牌运营团队，为您定制独特的合作方案",
              "多平台资源整合，最大化品牌曝光和影响力",
              "精准的目标用户定位，提高转化率和投资回报率",
            ],
            市场推广: [
              "全方位市场分析，找准目标用户群体和市场机会",
              "创新的推广策略和营销手段，提升品牌知名度",
              "实时监控推广效果，及时调整优化推广策略",
              "多渠道推广覆盖，包括线上线下等多种形式",
            ],
            数据分析: [
              "专业的数据分析团队，提供详细的业务数据报告",
              "实时数据监控，让您随时了解业务发展状况",
              "数据驱动决策，为业务优化提供科学依据",
              "竞品分析和市场趋势预测，帮助您掌握市场主动权",
            ],
          },
          get currentFeatures() {
            return (
              this.featuresData[this.activeCategory] ||
              this.featuresData["品牌合作"]
            );
          },
        },
      ],
      NewPartnerSlides: [
        {
          title: "成为渠道伙伴  学习变现思维",
          subtitle: "成为渠道合作伙伴",
          activeCategory: "适合谁加入？",
          categories: ["适合谁加入？", "申请优势", "合作流程"],
          featuresData: [
            {
              title: "适合谁加入？",
              type: 0, // 0=简单列表, 1=卡片式, 2=步骤式
              content: [
                '想拓展变现渠道的自媒体创业者，让 "内容影响力" 叠加 "渠道运营力"',
                '有博主资源积累的中间人，把人脉变成可持续收益的 "管道"',
                "想探索副业增收的自由职业者，用灵活合作模式适配多元生活节奏",
                "尝试团队新业务的中小机构，以轻资产模式测试内容变现可能性",
              ],
            },
            {
              title: "申请优势",
              type: 1, // 0=简单列表, 1=卡片式, 2=步骤式
              content: [
                {
                  title: "加入渠道伙伴，开启变现新局",
                  content:
                    "想打破常规、从学习中挖掘变现新路径？机会来了 —— 加入我们的渠道伙伴计划，携手挖掘内容变现新可能！为什么选择成为渠道伙伴？",
                },
                {
                  title: "低门槛启动，无需复杂资质",
                  content:
                    '无需复杂资质，填写联系方式即可申请，把 "想尝试" 变成 "能开始"，降低合作启动成本专属服务链：提交申请后，1 个工作日内专属对接人跟进，从流程指导到合作落地，全程有人帮、有人带',
                },
              ],
            },
            {
              title: "合作流程",
              type: 2, // 0=简单列表, 1=卡片式, 2=步骤式
              Ctitle: "合作流程有多简单？",
              content: [
                "填信息：提交基本资料，1 分钟完成申请动作，把意向转化为实际推进",
                "专人联：1 个工作日内对接人主动联系，解答疑问、梳理合作细节，让你清晰每一步",
                "启合作：确认细节后正式建立合作，快速进入变现轨道，把规划落地为收益",
              ],
            },
          ],
          getCurrentFeatures() {
            const feature = this.featuresData.find(
              (item) => item.title === this.activeCategory
            );
            return feature || this.featuresData[0];
          },
        },
        {
          title: "成为达人  学习变现思维",
          subtitle: "成为达人",
          activeCategory: "为什么要当平台达人？",
          categories: [
            "为什么要当平台达人？",
            "怎么开启达人变现？",
            "适合谁当达人？",
          ],
          featuresData: [
            {
              title: "为什么要当平台达人？",
              type: 1,
              content: [
                {
                  title: "照片变收益",
                  content:
                    "照片变收益：发布原创照片，用户购买就能赚，把你的镜头故事，变成持续现金流",
                },
                {
                  title: "流量有扶持",
                  content:
                    "平台助力优质内容曝光，给你的作品、知识更多被看见的机会，让变现更顺、更稳",
                },
              ],
            },
            {
              title: "怎么开启达人变现？",
              type: 1,
              content: [
                {
                  title: "注册认证",
                  content:
                    "填写信息、完成达人认证，1 步打通 “创作 - 变现” 通道",
                },
                {
                  title: "内容上架",
                  content:
                    "上传照片、知识内容（课程 / 经验贴等 ），设置售卖形式，简单操作就能上架开卖",
                },
                {
                  title: "用户买单",
                  content:
                    "平台流量加持，吸引用户购买，收益直接到账，“才” 变 “财” 就是这么快",
                },
              ],
            },
            {
              title: "怎么开启达人变现？",
              type: 0,
              content: [
                "深度合作，打造双赢局面，共同推动业务增长",
                "专业的品牌运营团队，为您定制独特的合作方案",
                "多平台资源整合，最大化品牌曝光和影响力",
                "精准的目标用户定位，提高转化率和投资回报率",
              ],
            },

            {
              title: "适合谁当达人？",
              type: 0,
              content: [
                "爱拍照、懂构图的摄影爱好者，让旅行、生活中的美好瞬间，变成收益点",
                "有技能、有经验的 “知识咖”，不管是职场技巧、手工技能，还是学科知识，都能教别人、赚收益",
                "想副业增收的斜杠青年，把碎片时间用来创作，让 “兴趣 + 知识” 双驱动变现",
                "想打造个人 IP 的创作者，用持续输出积累粉丝、沉淀价值，让 “达人身份” 成为个人品牌的助推器",
              ],
            },
          ],
          getCurrentFeatures() {
            const feature = this.featuresData.find(
              (item) => item.title === this.activeCategory
            );
            return feature || this.featuresData[0];
          },
        },
      ],

      // 下载模态框
      downloadModalVisible: false,
      downloadPlatform: "",

      // 二维码可见性状态
      qrCodeVisible: {
        apple: false,
        android: false,
        footer_apple: false,
        footer_android: false,
      },

      // 下拉菜单可见性状态
      dropdownVisible: false,

      // 移动端菜单状态
      mobileMenuOpen: false,
      mobileDropdownOpen: false,
      // 手机轮播相关
      currentPhoneSlide: 0,
      phoneImages: [
        { src: null, alt: "手机界面1" },
        { src: null, alt: "手机界面2" },
        { src: null, alt: "手机界面3" },
        { src: null, alt: "手机界面4" },
        { src: null, alt: "手机界面5" },
      ],

      // 触摸相关
      touchStartX: 0,
      touchStartY: 0,
      isTouching: false,
      autoPlayTimer: null,
    };
  },

  computed: {},

  mounted() {
    // 导航栏滚动效果
    window.addEventListener("scroll", this.handleNavbarScroll);

    // 页面加载动画
    this.initScrollAnimations();

    // 初始化手机轮播图片
    this.initPhoneImages();

    // 初始化安卓二维码
    this.initAndroidQrCode();

    // 启动自动播放
    this.startAutoPlay();
  },
  created() {
    // this.getPackageList();
    // this.getPayTypeList();
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleNavbarScroll);
    // 清除自动播放定时器
    this.clearAutoPlay();
  },

  methods: {
    /**
     * 点击下载指定平台App
     * @param type 下载平台 'android' 或 'ios'
     */
    clickToDownload(type) {
      const url = type === "android" ? this.android_url : this.ios_url;
      if (!url) return;
      window.location.href = url;
    },

    // 移动端点击直接下载
    handleDownloadClick(type) {
      if (this.isMobileDevice()) {
        this.clickToDownload(type);
      }
    },

    isMobileDevice() {
      return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    /**获取支付类型 */
    async getPayTypeList() {
      let res = await getDict({ key: "payment_type" });
      if (res.code == 200) {
        let firstTime =
          res.data?.map((item) => {
            return {
              Sort: item.dictSort,
              Text: item.dictValue,
            };
          }) || [];
        let payModeList = this.getPayTypeConfig(firstTime);
        this.payModeList = payModeList;
      } else {
        this.payModeList = [];
      }
    },
    /**
     * 筛选可支付方式
     * @param payTypeList 已经启用的支付方式
     */
    getPayTypeConfig(payTypeList = []) {
      const map = {
        微信: "微信支付",
        支付宝: "支付宝支付",
      };

      const result = [];
      const sortedList = [...payTypeList].sort((a, b) => a.Sort - b.Sort);
      sortedList.forEach((item) => {
        if (map[item.Text]) {
          result.push(map[item.Text]);
        }
      });
      return result;
    },
    /**获取套餐数据 */
    async getPackageList() {
      let res = await findRecharge();
      if (res.code == 200) {
        this.packageList = res.data;
      }
    },

    // 充值标签页切换
    switchTab(tab) {
      this.activeTab = tab;
      this.selectedPrice = 0;
      this.selectedIndex = null;
      // this.customAmount = 0
    },

    // 选择价格
    selectPrice(packageList, index) {
      // 如果点击的是已选中的价格，则取消选择
      if (this.selectedIndex === index) {
        this.selectedIndex = null;
        this.selectedPrice = 0;
      } else {
        this.selectedIndex = index;
        this.selectedPrice = packageList.rechargeAmount;
        this.customAmount = ""; // 清除自定义金额
        // 添加触觉反馈（如果支持）
        if (navigator.vibrate) {
          navigator.vibrate(50);
        }
      }
    },
    // 搜索功能
    async handleSearch() {
      if (this.searchQuery.trim()) {
        try {
          let res = await getHiUser({ phone: this.searchQuery });
          if (res.code == 200) {
            this.userInfo = {
              id: res.data.id,
              name: res.data.userName,
              avatar: res.data.userIcon,
            };
          } else {
            this.$message.error(res.msg || "搜索用户失败");
          }
        } catch (error) {
          this.$message.error("搜索失败，请检查网络连接");
        }
      } else {
        this.$message.error("请输入手机号");
      }
    },

    // 自定义充值金额处理
    handleCustomAmountChange() {
      if (this.customAmount && this.customAmount > 0) {
        this.selectedPrice = parseFloat(this.customAmount);
        this.selectedIndex = null; // 清除官方数额的选择
      } else {
        this.selectedPrice = 0;
      }
    },

    // 重置用户信息
    resetUserInfo() {
      this.userInfo = {
        id: "",
        name: "",
        avatar: "",
      };
      this.searchQuery = "";
    },
    // 隐藏充值弹窗
    hideRechargeModal() {
      this.rechargeShow = false;
      this.rechargeQrCode = "";
    },
    /**确认充值 */
    async confirmRecharge() {
      let that = this;

      let {
        activeTab,
        selectedPrice,
        customAmount,
        userInfo,
        payModeList,
        payModeIndex,
      } = that;
      let transAmtMoney;
      if (that.userInfo.id == "") {
        that.$message.error("请先搜索用户");
        return;
      }
      if (activeTab == "digital") {
        if (selectedPrice == 0) {
          that.$message.error("请选择充值套餐");
          return;
        }
        transAmtMoney = +selectedPrice;
      } else if (activeTab == "other") {
        if (customAmount == "") {
          that.$message.error("请输入充值金额");
          return;
        }
        const amount = Number(customAmount);
        if (!Number.isInteger(amount)) {
          that.$message.error("充值金额必须是整数");
          return;
        }
        if (amount < 18) {
          that.$message.error("最低充值金额为18元");
          return;
        }

        transAmtMoney = +customAmount;
      }
      let { date: reqDate, dateTime: timeExpire } = getCurrentDateTime(2);
      // let reqSeqId = generateOrderNo("HQSFT"); //商付通
      let reqSeqId = generateOrderNo("HQSmartPay"); //Smartpay
      let Title = payModeList[payModeIndex] == "支付宝支付" ? "支付宝" : "微信";
      this.PayTitle = "请用" + Title + "扫码进行支付";
      // =======================汇付斗拱=================================
      // let params = {
      //   // 商品描述
      //   goodsDesc: "充值嗨果",
      //   // 请求日期
      //   reqDate,
      //   // 请求流水号
      //   reqSeqId,
      //   // 关单时间
      //   timeExpire,
      //   // 交易类型
      //   tradeType: "A_NATIVE",
      //   // 交易金额
      //   transAmt: transAmtMoney.toFixed(2),
      // };
      //   this.rechargeOrder = {
      //   orgReqDate: reqDate,
      //   orgReqSeqId: reqSeqId,
      //   userId: userInfo.id,
      // };
      let params = {
        // 商品描述
        subject: "嗨果加值",
        // 请求日期
        // reqDate,
        // 关单时间
        // timeExpire,
        // 请求流水号
        outTradeNo: reqSeqId,
        // 商付通交易类型 WECHAT微信 ALIPAY支付宝
        // Smartpay交易类型 1微信 2支付宝
        tradeType: Title == "支付宝" ? "2" : "1",
        // 交易金额
        totalAmount: transAmtMoney.toFixed(2),
        // 下单类型：1:加入圈子,2:购买微信,3:购买图片,4:购买动态,5:购买会员,6:充值嗨果
        addType: 6,
        // 用户userID
        userId: that.userInfo.id,
      };
      const loading = this.$loading({
        lock: true,
        text: "正在生成支付二维码，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // let res = await payAlipayUrl(params); // 汇付斗拱
      // let res = await paySFTUrl(params); // 商付通
      let resBeforeReturn = await paySmartpayUrl(params); // Smartpay
      let res = getPayUrlSmartpay(resBeforeReturn); // Smartpay
      if (res.code == 200) {
        loading.close();
        // let { qr_code } = res.data; // 汇付斗拱
        // let { bizData } = res.data; // 商付通
        // let scheme = getPayUrlSFT(bizData); // 商付通
        let scheme = res.data.payUrl; // Smartpay
        // 下单充值二维码
        QRCode.toDataURL(scheme).then((qr_code_url) => {
          this.rechargeQrCode = qr_code_url;
          this.rechargeShow = true;
        });
      } else {
        loading.close();
        that.$message.error(res.msg);
      }
    },
    /**
     * 点击 我已支付======汇付斗拱
     */
    async confirmPaymentHFDG() {
      let { rechargeOrder } = this;
      const loading = this.$loading({
        lock: true,
        text: "正在校验支付,请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = await userRecharge(rechargeOrder);
      if (res.code == 200) {
        this.$message.success("充值成功");
        this.rechargeOrder = {};
        loading.close();
        this.hideRechargeModal();
      } else {
        this.$message.error(res.msg);
        this.rechargeOrder = {};
        loading.close();
        this.hideRechargeModal();
      }
    },
    /**
     * 点击 我已支付======商付通/Smartpay
     */
    async confirmPaymentSFTSmartpay() {
      const loading = this.$loading({
        lock: true,
        text: "正在校验支付,请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.rechargeOrder = {};
      loading.close();
      this.hideRechargeModal();
    },
    // 导航栏滚动效果
    handleNavbarScroll() {
      const navbar = document.querySelector(".navbar");
      if (navbar) {
        if (window.scrollY > 50) {
          navbar.style.background = "rgba(255, 255, 255, 0.98)";
        } else {
          navbar.style.background = "rgba(255, 255, 255, 0.95)";
        }
      }
    },
    // 轮播图切换方法
    nextSlide() {
      if (this.currentSlide < this.NewPartnerSlides.length - 1) {
        this.currentSlide++;
      }
    },

    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--;
      }
    },

    goToSlide(index) {
      this.currentSlide = index;
    },

    // 单个slide分类切换
    switchSlideCategory(slideIndex, category) {
      this.NewPartnerSlides[slideIndex].activeCategory = category;
    },

    // 跳转到锚点
    scrollToAnchor(anchorId) {
      const element = document.getElementById(anchorId);
      if (element) {
        // 获取导航栏高度，避免被遮挡
        const navbar = document.querySelector(".navbar");
        const navbarHeight = navbar ? navbar.offsetHeight : 80;

        // 计算目标位置并直接跳转
        const targetTop = element.offsetTop - navbarHeight;
        window.scrollTo(0, targetTop);
      }
    },

    // 跳转到合作伙伴页面并设置轮播图
    navigateToPartnerPage(slideIndex) {
      // 首先设置当前轮播图索引
      this.currentSlide = slideIndex;

      // 隐藏下拉菜单
      this.hideDropdown();

      // 使用 $nextTick 确保 DOM 更新后再执行滚动
      this.$nextTick(() => {
        const element = document.getElementById("partner");
        if (element) {
          // 获取导航栏高度，避免被遮挡
          const navbar = document.querySelector(".navbar");
          const navbarHeight = navbar ? navbar.offsetHeight : 80;

          // 计算目标位置并滚动
          const targetTop = element.offsetTop - navbarHeight;
          window.scrollTo({
            top: targetTop,
            behavior: "smooth",
          });
        }
      });
    },

    // 隐藏协议弹窗
    hideAgreementModal() {
      this.showAgreement = false;
    },

    // 获取协议内容
    async getAgreementContent() {
      if (this.agreementContent) return; // 已加载过则不再重复请求

      this.agreementLoading = true;
      try {
        const res = await findHiAgreement({ tab: 6 });
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.agreementContent = res.data[0].contexts || "";
        } else {
          this.$message.error(res.msg || "获取协议内容失败");
        }
      } catch (error) {
        console.error("获取协议内容失败:", error);
        this.$message.error("获取协议内容失败，请稍后重试");
      } finally {
        this.agreementLoading = false;
      }
    },

    // 点击协议链接
    async showAgreementClick() {
      this.showAgreement = true;
      await this.getAgreementContent();
    },

    // 手机图片悬停效果
    handlePhoneHover(event, isEnter) {
      if (isEnter) {
        event.target.style.transform = "translateY(-10px) scale(1.05)";
        event.target.style.zIndex = "10";
      } else {
        event.target.style.transform = "translateY(0) scale(1)";
        event.target.style.zIndex = "1";
      }
    },

    // 初始化安卓二维码
    initAndroidQrCode() {
      if (!this.android_url) return;
      QRCode.toDataURL(this.android_url)
        .then((qr_code_url) => {
          this.androidQrCode = qr_code_url;
        })
        .catch((error) => {
          console.error("生成安卓二维码失败:", error);
        });
    },

    // 显示下载模态框
    showDownloadModal(platform) {
      this.downloadPlatform = platform;
      this.downloadModalVisible = true;
    },

    // 隐藏下载模态框
    hideDownloadModal() {
      this.downloadModalVisible = false;
    },

    // 确认下载
    confirmDownload() {
      // 这里可以添加实际的下载逻辑
      this.hideDownloadModal();
      console.log(`下载 ${this.downloadPlatform} 应用`);
    },

    // 选择支付方式
    selectPaymentMode(index) {
      if (!this.selectedPrice) {
        this.$message.error("请先选择充值金额");
        return;
      }
      this.payModeIndex = index;
    },

    // 初始化滚动动画
    initScrollAnimations() {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = "1";
            entry.target.style.transform = "translateY(0)";
          }
        });
      }, observerOptions);

      // 为需要动画的元素添加观察
      this.$nextTick(() => {
        const animatedElements = document.querySelectorAll(
          ".price-card, .phone-image, .feature-item"
        );
        animatedElements.forEach((el) => {
          el.style.opacity = "0";
          el.style.transform = "translateY(30px)";
          el.style.transition = "all 0.6s ease";
          observer.observe(el);
        });
      });
    },

    // 显示二维码
    showQRCode(type) {
      if (type === "android" && !this.androidQrCode) {
        this.initAndroidQrCode();
      }
      this.qrCodeVisible[type] = true;
    },

    // 隐藏二维码
    hideQRCode(type) {
      this.qrCodeVisible[type] = false;
    },

    // 显示下拉菜单
    showDropdown() {
      this.dropdownVisible = true;
    },

    // 隐藏下拉菜单
    hideDropdown() {
      this.dropdownVisible = false;
    },

    // 跳转到手机网页版
    goToMobileWeb() {
      // 在新窗口/标签页中打开指定网站
      window.open(this.H5_url, "_blank");
    },

    // 移动端菜单控制
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      // 如果打开移动菜单时关闭下拉菜单
      if (this.mobileMenuOpen) {
        this.mobileDropdownOpen = false;
      }
    },

    closeMobileMenu(anchor = null) {
      this.mobileMenuOpen = false;
      this.mobileDropdownOpen = false;
      if (anchor) {
        this.scrollToAnchor(anchor);
      }
    },

    toggleMobileDropdown() {
      this.mobileDropdownOpen = !this.mobileDropdownOpen;
    },

    navigateToPartnerPageMobile(slideIndex) {
      // 关闭移动菜单
      this.closeMobileMenu();
      // 设置轮播图索引并跳转
      this.navigateToPartnerPage(slideIndex);
    },

    // 手机轮播相关方法
    initPhoneImages() {
      this.phoneImages = [
        { src: this.icon_phone1, alt: "手机界面1" },
        { src: this.icon_phone2, alt: "手机界面2" },
        { src: this.icon_phone3, alt: "手机界面3" },
        { src: this.icon_phone4, alt: "手机界面4" },
        { src: this.icon_phone5, alt: "手机界面5" },
      ];
    },

    goToPhoneSlide(index) {
      this.currentPhoneSlide = index;
      this.restartAutoPlay();
    },

    nextPhoneSlide() {
      this.currentPhoneSlide =
        (this.currentPhoneSlide + 1) % this.phoneImages.length;
    },

    prevPhoneSlide() {
      this.currentPhoneSlide =
        this.currentPhoneSlide === 0
          ? this.phoneImages.length - 1
          : this.currentPhoneSlide - 1;
    },

    startAutoPlay() {
      this.clearAutoPlay();
      this.autoPlayTimer = setInterval(() => {
        if (!this.isTouching) {
          this.nextPhoneSlide();
        }
      }, 3000); // 3秒自动切换
    },

    clearAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    },

    restartAutoPlay() {
      this.clearAutoPlay();
      this.startAutoPlay();
    },

    // 触摸事件处理
    handleTouchStart(event) {
      this.isTouching = true;
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
    },

    handleTouchMove(event) {
      // 防止页面滚动
      if (this.isTouching) {
        event.preventDefault();
      }
    },

    handleTouchEnd(event) {
      if (!this.isTouching) return;

      const touchEndX = event.changedTouches[0].clientX;
      const touchEndY = event.changedTouches[0].clientY;
      const deltaX = touchEndX - this.touchStartX;
      const deltaY = touchEndY - this.touchStartY;

      // 判断是水平滑动还是垂直滑动
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
        if (deltaX > 0) {
          // 向右滑动，显示上一张
          this.prevPhoneSlide();
        } else {
          // 向左滑动，显示下一张
          this.nextPhoneSlide();
        }
        this.restartAutoPlay();
      }

      this.isTouching = false;
    },
  },
};
</script>

<style scoped lang="less">
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 确保平滑滚动正常工作 */
html {
  scroll-behavior: smooth;
}

.home-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  line-height: 1.6;
  color: #333;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 导航栏样式 */
.navbar {
  background: rgba(253, 253, 253, 0.55);
  backdrop-filter: blur(10px);
  padding: 15px 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999; /* 提高 z-index 确保在最顶层 */
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);

  .container {
    display: flex;
    align-items: center;
  }
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo {
  width: 32px;
  height: 32px;
  background: linear-gradient(45deg, #8b5cf6, #a855f7);
  border-radius: 8px;
}

.brand-text {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 80px;
  margin-left: 120px;
}

.nav-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  width: 100px;
  height: 36px;
  font-size: 14px;
  color: #fff;
  background: linear-gradient(90deg, #a167f3 0%, #477ff3 100%);
  border-radius: 19px 19px 19px 19px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(161, 103, 243, 0.4);
  }
}

.nav-item {
  text-decoration: none;
  color: #333333;
  font-weight: 500;
  transition: color 0.3s ease;
  cursor: pointer;

  &:hover {
    color: #8b5cf6;
  }
}

.nav-dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1000;

  &.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}

.dropdown-item {
  display: block;
  padding: 12px 16px;
  color: #333333;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.3s ease;

  &:last-child {
    border-bottom: none;
    border-radius: 0 0 8px 8px;
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:hover {
    background-color: #f8f9fa;
    color: #8b5cf6;
  }
}

.download-btn {
  background: #333333;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #555555;
    transform: translateY(-2px);
  }
}

/* 主要内容区域 */
main {
  // margin-top: 80px;
}

/* 应用展示区域 */
.hero-section {
  padding: 90px 0;
  background: url("@/assets/bg.png") center/cover no-repeat,
    linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.hero-title {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #390071;
  // text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: 18px;
  font-weight: bold;
  opacity: 0.9;
  color: #390071;
}

// .phone-mockups {
//   background-color: yellow;
// }

/* 桌面端瀑布流布局 */
.desktop-phone-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

/* 移动端轮播布局 - 默认隐藏 */
.mobile-phone-carousel {
  display: none;
}

.phone-image {
  width: 200px;
  height: 400px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease;
  cursor: pointer;
}
.phone-imageTwo {
  margin-top: 120px;
}
.phone-imageThree {
  margin-top: 40px;
}
.phone-imageFour {
  margin-top: 120px;
}

// .phone-imageFive{
//   margin-top: 40px;
// }

.download-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  flex-wrap: wrap;
  position: relative;
  z-index: 2;
}

.download-btn {
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 10px 24px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  min-width: 180px;
  position: relative;

  &:hover {
    background: rgba(0, 0, 0, 0.9);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }
}

.btn-content {
  display: flex;
  flex-direction: row;
  align-items: center;

  .btn-content-left {
    width: 35px;
    height: 35px;
  }

  .btn-content-right {
    display: flex;
    flex-direction: column;
    align-items: center;

    .btn-text-small {
      font-size: 12px;
      opacity: 0.8;
    }

    .btn-text-large {
      margin-left: 10px;
      font-size: 18px;
      font-weight: 600;
    }
  }
}

/* 二维码弹出框样式 */
.qr-popup {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-10px);
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  min-width: 200px;

  &.show {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(-15px);
  }

  &::before {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid white;
  }
}

.qr-code {
  width: 160px;
  height: 160px;
  margin: 0 auto 12px;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.qr-text {
  text-align: center;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.app-store-btn,
.play-store-btn {
  background: rgba(0, 0, 0, 0.8);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }
}

/* 嗨果充值区域 */
.recharge-section {
  padding: 80px 0;
  background: #f3f5f9;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 32px;
  font-weight: bold;
  color: #333;
}

.title-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.title-exclaim {
  width: 24px;
  height: 24px;
  vertical-align: top;
  position: relative;
  top: -8px;
}

.search-container {
  display: flex;
  align-items: center;
}

.search-box {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  width: 484px;
  border: 1px solid #e5e5e7;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.search-icon {
  width: 18px;
  height: 18px;
  margin-left: 16px;
  opacity: 0.5;
}

.search-input {
  border: none;
  outline: none;
  background: transparent;
  padding: 14px 12px 14px 14px;
  font-size: 14px;
  color: #333;
  flex: 1;

  &::placeholder {
    color: #a3a3a3;
  }
}

.search-btn {
  margin: 5px;

  color: white;
  border: none;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;
  background: linear-gradient(180deg, #a167f3 0%, #477ff3 100%);
  border-radius: 8px 8px 8px 8px;
  transition: all 0.3s ease;
  margin: 5px;
  &:hover {
    background: linear-gradient(135deg, #7c6ef0 0%, #5d4ff0 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(139, 124, 246, 0.3);
  }
}

/* 用户信息卡片样式 */
.user-info-card {
  display: flex;
  align-items: center;
  gap: 15px;
  background: linear-gradient(135deg, #6b73ff 0%, #9a40d3 100%);
  border-radius: 20px;
  padding: 5px 20px;
  min-width: 380px;
  box-shadow: 0 4px 15px rgba(107, 115, 255, 0.3);
}

.user-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.user-details {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: white;
  font-size: 14px;

  .user-info-row {
    display: flex;
    flex: 1;
    align-items: center;
    gap: 20px;
  }

  .user-nickname {
    font-weight: 600;
  }

  .user-id {
    opacity: 0.9;
    font-size: 13px;
  }
  .user-info-rowT {
    color: white;
    font-size: 12px;
    padding: 4px 12px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: translateY(-1px);
    }
  }
}

.recharge-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 40px;
  background: #f3f5f9;
  border-radius: 12px;
  padding: 6px;
  width: fit-content;
}

.tab-btn {
  cursor: pointer;
  transition: all 0.3s ease;
  width: 112px;
  height: 48px;
  background: transparent;
  color: #9b6ff5;
  border: 1px solid #9b6ff5;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;

  &.active {
    background: linear-gradient(180deg, #a167f3 0%, #477ff3 100%);
    color: white;
    border: none;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  }

  &:hover:not(.active) {
    background: rgba(155, 111, 245, 0.1);
  }
}

.price-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 60px;
}

.price-card {
  background: white;
  border-radius: 15px;
  padding: 30px 20px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;

  &:hover:not(.selected) {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    border-color: rgba(139, 92, 246, 0.3);
  }

  &:active {
    transform: translateY(-2px) scale(0.98);
    transition: all 0.1s ease;
  }

  &.featured {
    color: white;
    border-color: transparent;
    background: #915bff;
    box-shadow: 0px 0px 12px 1px rgba(145, 91, 255, 0.4);
    border-radius: 12px 12px 12px 12px;
  }

  &.hot {
    border-color: #ff6b6b;
  }
}

.hot-label {
  position: absolute;
  top: -2px;
  left: 19%;
  transform: translateX(-50%);
  color: white;
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 12px;
  width: 82px;
  height: 28px;
  background: linear-gradient(180deg, #a167f3 0%, #6247f3 100%);
  border-radius: 12px 0px 12px 0px;
}

.price-badge {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  .price-badge-icon {
    width: 20px;
    height: 20px;
  }
}

.price-amount {
  font-size: 18px;
  color: #666;
}

.price-card.featured .price-amount {
  color: rgba(255, 255, 255, 0.9);
}

/* 自定义充值金额区域 */
.custom-amount-section {
  margin-bottom: 60px;
}

.custom-amount-input-container {
  background: white;
  border-radius: 15px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 2px solid transparent;
  transition: all 0.3s ease;
  max-width: 500px;

  &:focus-within {
    border-color: #8b5cf6;
    box-shadow: 0 4px 20px rgba(139, 92, 246, 0.2);
  }
}

.custom-amount-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.custom-amount-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 18px;
  color: #333;
  flex: 1;
  padding: 8px 0;

  &::placeholder {
    color: #a3a3a3;
    font-size: 16px;
  }

  /* 移除 number 类型输入框的箭头 */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type="number"] {
    -moz-appearance: textfield;
  }
}

/* 支付区域 */
.payment-section {
  background: #f8f9fa;
  padding: 40px;
  border-radius: 20px;
}

.payment-left {
  margin-bottom: 30px;
}

.payment-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.payment-btn {
  background: #f8f9fa;
  color: #666;
  border: 2px solid #e0e0e0;
  padding: 8px 20px;
  border-radius: 12px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
  flex: 0 0 calc(50% - 10px);
  min-width: 140px;
  max-width: 200px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #515dff;
    color: #515dff;
  }

  &.active {
    background: #515dff;
    color: white;
    border-color: #515dff;
    box-shadow: 0 4px 15px rgba(81, 93, 255, 0.4);
    transform: translateY(-1px);
  }
}

.payment-methods {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
}

.payment-notice {
  color: #ff4d4f;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.amount-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.amount-info {
  flex: 1;
}

.amount-label {
  font-weight: bold;
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
}

.amount-details {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.amount-description {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.confirm-btn {
  background-color: #633eff;
  color: white;
  border: none;
  width: 112px;
  height: 48px;
  background: #633eff;
  border-radius: 8px 8px 8px 8px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
  }
}

/* 成为渠道伙伴区域 */
.partner-section {
  padding: 10px 0 150px 0;
  color: white;
  position: relative;
  overflow: hidden;
  background: #f3f5f9 url("@/assets/partner_bg.png") no-repeat left top;
  background-size: 75% auto; /* 宽度占容器 75%，高度自适应 */
}

/* 新版本数据样式 - 预留给用户自定义 */

/* Type 0: 简单列表样式预留类名 */
.feature-type-0 {
  /* 用户可自定义 type 0 的整体容器样式 */
}

.feature-item-type-0 {
  /* 用户可自定义 type 0 的单个项目样式 */
}

/* Type 1: 复杂卡片样式预留类名 */
.feature-type-1 {
  /* 用户可自定义 type 1 的整体容器样式 */
}

.feature-item-type-1 {
  /* 用户可自定义 type 1 的单个项目样式 */
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;
}

.feature-item-type-1.has-divider {
  /* 下边框分隔符样式 */
  border-bottom: 1px solid rgba(139, 92, 246, 0.3);
  padding-bottom: 20px;
}

.feature-card-title {
  /* 用户可自定义 type 1 卡片标题样式 */
  font-weight: bold;
  color: #333;
  display: block;
  width: 100%;
  margin-bottom: 2px; /* 进一步减小下边距 */
}

.feature-card-content {
  /* 用户可自定义 type 1 卡片内容样式 */
  line-height: 1.6;
  color: #666;
  display: block;
  width: 100%;
  margin-top: 0; /* 移除上边距 */
}

/* Type 2: 流程步骤样式预留类名 */
.feature-type-2 {
  /* 用户可自定义 type 2 的整体容器样式 */
}

.feature-item-type-2 {
  /* 用户可自定义 type 2 的单个项目样式 */
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
  line-height: 1.4;
}

.feature-step-number {
  /* 用户可自定义 type 2 步骤编号样式 */
  width: 20px;
  height: 20px;
  background: #8b5cf6;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
  margin-top: 2px;
}

.feature-item-type-2 .feature-text {
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
}

/* 自定义标题样式 */
.feature-custom-title {
  /* 用户可自定义 Ctitle 的样式 */
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

/* 轮播图容器 */
.carousel-container {
  position: relative;
  width: 100%;
  overflow: visible;
  margin-bottom: 60px;
}

.carousel-wrapper {
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 100%;
}

.carousel-slide {
  flex: 0 0 100%;
  width: 100%;
}

.partner-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 60px;
  align-items: start;
}

.partner-title {
  margin: 50px 0;
  font-size: 46px;
  font-weight: bold;
  text-align: center;
  line-height: 1.2;
  // background-color: yellow;
}
.partner-subtitle {
  margin-left: 20px;
  margin-bottom: 40px;
  font-size: 26px;
  color: #ffffff;
}

.partner-nav {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
  padding-left: 10px;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0px;
    bottom: 0;
    width: 3px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 2px;
  }
}

.partner-nav-title {
  font-size: 20px;
  font-weight: 600;
  color: white;
  text-align: center;
  margin-bottom: 30px;
  padding: 0 8px;
  line-height: 1.3;
}

.partner-nav-item {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  padding: 8px 0;
  transition: all 0.3s ease;
  cursor: pointer;
  background: transparent;
  border: none;
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 8px;
  position: relative;

  &:hover {
    color: white;
  }

  &.active {
    color: white;
    font-weight: 500;
    background: linear-gradient(
      88deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    padding: 8px 24px 8px 8px;
    margin-left: -8px;
    border-radius: 0 8px 8px 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.partner-right {
  margin-top: 10px;
  position: relative;
  // height: 300px; /* 固定高度，用户可根据需要调整 */
  overflow: hidden; /* 防止内容溢出 */
  width: 120%; /* 设置宽度超出父元素 */
  max-width: none; /* 移除最大宽度限制 */
  box-sizing: border-box;
}

.partner-features {
  height: 100%;
  overflow-y: hidden; /* 隐藏滚动条 */
  color: #333;
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 20px; /* 减小内边距 */
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-sizing: border-box; /* 确保padding包含在高度内 */
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 25px;
}
.feature-item-icon {
  width: 20px;
  height: 20px;
}
.feature-text {
  line-height: 1.6;
  opacity: 0.9;
}

/* 轮播图控制按钮 */
.carousel-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  pointer-events: none;
  z-index: 10;
}

.carousel-btn {
  width: 50px;
  height: 50px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    transform: scale(1.1);
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

.btn-icon {
  width: 50px;
  height: 50px;
  transition: transform 0.3s ease;
}

.prev-icon {
  transform: rotate(180deg);
}

.next-icon {
  transform: rotate(0deg);
}

.carousel-btn:hover:not(:disabled) .btn-icon {
  transform: scale(1.1) rotate(0deg);
}

.carousel-btn:hover:not(:disabled) .prev-icon {
  transform: scale(1.1) rotate(180deg);
}

/* 轮播图指示器 */
.carousel-indicators {
  position: absolute;
  bottom: -150px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 10;
}

.indicator {
  width: 40px;
  height: 4px;
  border-radius: 2px;
  border: none;
  background: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;

  &.active {
    background: white;
    transform: scaleX(1.2);
  }

  &:hover:not(.active) {
    background: rgba(255, 255, 255, 0.5);
  }
}

/* 关于我们区域 */
.about-section {
  padding: 130px 0;
  background: #f3f5f9;
  position: relative;
  overflow: hidden;
}

.about-text {
  margin-top: 20px;
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  max-width: 800px;
  text-align: justify;
}
.about-text-t {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  max-width: 800px;
  text-align: justify;
}
/* 气泡装饰样式 */
.bubble {
  position: absolute;
  width: 420px;
  height: 420px;

  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
}

.bubble-top-left {
  top: -110px;
  left: -210px;
  width: 420px;
  height: 420px;
  background-image: url("@/assets/bubble_left.png");
  animation: float-up-left 4s ease-in-out infinite;
}

.bubble-bottom-right {
  bottom: -125px;
  right: -125px;
  width: 420px;
  height: 420px;
  background-image: url("@/assets/bubble_right.png");
  animation: float-down-right 5s ease-in-out infinite;
}

/* 气泡浮动动画 */
@keyframes float-up-left {
  0% {
    transform: translateY(-50px) translateX(0) rotate(0deg) scale(1);
  }
  50% {
    transform: translateY(50px) translateX(5px) rotate(3deg) scale(1.02);
  }
  100% {
    transform: translateY(-50px) translateX(0) rotate(0deg) scale(1);
  }
}

@keyframes float-down-right {
  0% {
    transform: translateY(50px) translateX(0) rotate(0deg) scale(1);
  }
  50% {
    transform: translateY(-50px) translateX(-5px) rotate(-3deg) scale(1.02);
  }
  100% {
    transform: translateY(50px) translateX(0) rotate(0deg) scale(1);
  }
}

/* 页脚 */
.footer {
  background: #2d3748;
  color: white;
  padding: 40px 0;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.footer-contact {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  span {
    color: white;
    font-size: 16px;
    font-weight: 500;
  }

  img {
    width: 80px;
    height: 80px;
    object-fit: contain;
    border-radius: 4px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
      opacity: 0.8;
    }
  }
}

.footer-downloads {
  display: flex;
  gap: 15px;
}

.footer-download-btn {
  background: white;
  border: none;
  color: #333;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  min-width: 140px;

  .btn-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .btn-content-left {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }

    .btn-content-right {
      display: flex;
      align-items: center;

      .btn-text-large {
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  &:hover {
    background: #f5f5f5;
    color: #333;
    transform: translateY(-2px);
  }
}

/* 页脚二维码弹出框样式 */
.footer-qr-popup {
  position: absolute;
  top: -220px;
  left: 50%;
  transform: translateX(-50%) translateY(-10px);
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  min-width: 200px;

  &.show {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(-15px);
  }

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid white;
  }

  .qr-code img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .qr-text {
    text-align: center;
    color: #333;
    font-size: 14px;
    font-weight: 500;
  }
}

/* 充值支付弹窗样式 */
.qr-code-container {
  text-align: center;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.qr-code-image {
  width: 200px;
  height: 200px;
  object-fit: contain;
  border-radius: 8px;
  background: white;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e5e5;
  margin: 0 auto;
}

/* Element UI Dialog 自定义样式 */
::v-deep .el-dialog {
  border-radius: 12px;
  margin: 0 !important;
}

::v-deep .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

::v-deep .el-dialog__header {
  text-align: center;
  padding: 20px 20px 10px;
}

::v-deep .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

::v-deep .el-dialog__body {
  padding: 10px 20px;
}

::v-deep .el-dialog__footer {
  text-align: center;
  padding: 10px 20px 20px;
}

::v-deep .dialog-footer .el-button {
  min-width: 80px;
}

/* 下载模态框 */
.download-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 40px;
  border-radius: 20px;
  text-align: center;
  max-width: 400px;
  margin: 20px;

  h3 {
    margin-bottom: 20px;
    color: #333;
  }

  p {
    margin-bottom: 30px;
    color: #666;
  }
}

.modal-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.cancel-btn {
  background: #ccc;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
}

/* 移动端汉堡菜单样式 */
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  margin-left: auto;
  margin-right: 15px;
}

.hamburger-line {
  width: 24px;
  height: 3px;
  background-color: #333;
  border-radius: 2px;
  transition: all 0.3s ease;
  margin: 3px 0;
}

/* 移动端导航菜单 */
.mobile-nav {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(253, 253, 253, 0.98);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transform: translateY(-10px);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 999;
}

.mobile-nav.active {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}

.mobile-nav-item {
  display: block;
  padding: 15px 20px;
  color: #333;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.mobile-nav-item:hover {
  background: rgba(139, 92, 246, 0.1);
  color: #8b5cf6;
}

/* 移动端下拉菜单 */
.mobile-dropdown {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.mobile-dropdown-btn {
  width: 100%;
  padding: 15px 20px;
  background: none;
  border: none;
  text-align: left;
  color: #333;
  font-weight: 500;
  font-size: inherit;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.mobile-dropdown-btn:hover {
  background: rgba(139, 92, 246, 0.1);
  color: #8b5cf6;
}

.dropdown-arrow {
  transition: transform 0.3s ease;
  font-size: 12px;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.mobile-dropdown-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  background: rgba(0, 0, 0, 0.05);
}

.mobile-dropdown-content.show {
  max-height: 200px;
}

.mobile-dropdown-item {
  display: block;
  padding: 12px 40px;
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
}

.mobile-dropdown-item:hover {
  background: rgba(139, 92, 246, 0.1);
  color: #8b5cf6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    position: relative;
  }

  .desktop-menu {
    display: none;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .mobile-nav {
    display: block;
  }

  .nav-actions {
    order: 0;
  }

  .navbar {
    padding: 12px 0;
  }

  .nav-brand {
    margin-right: auto;
  }

  .brand-text {
    font-size: 18px;
  }

  .logo {
    width: 28px;
    height: 28px;
  }

  .nav-actions {
    width: 85px;
    height: 32px;
    font-size: 12px;
    margin-left: 0;
  }

  .hero-title {
    font-size: 32px;
  }

  .desktop-phone-group {
    grid-template-columns: repeat(2, 1fr);
  }

  /* 移动端隐藏桌面瀑布流，显示轮播 */
  .desktop-phone-group {
    display: none;
  }

  .mobile-phone-carousel {
    display: block;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    position: relative;
    padding: 0 20px;
    isolation: isolate; /* 创建新的堆叠上下文 */
    contain: layout style; /* 限制布局影响范围 */
  }

  .phone-carousel-container {
    width: 120%; /* 扩大容器宽度 */
    margin-left: -10%; /* 左边偏移 */
    overflow: hidden; /* 隐藏溢出部分 */
    position: relative;
    z-index: 1; /* 设置较低的 z-index */
    height: 350px; /* 固定容器高度，防止高度变化 */
  }

  .phone-carousel-wrapper {
    display: flex;
    width: 100%;
    height: 100%; /* 占满容器高度 */
    transition: transform 0.3s ease-out;
    will-change: transform;
    align-items: center;
    transform-origin: center;
  }

  .phone-carousel-slide {
    width: 60%; /* 每个slide占60%宽度 */
    flex: 0 0 60%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    box-sizing: border-box;
    height: 100%; /* 占满容器高度 */
    transition: all 0.3s ease;
  }

  .phone-image-carousel {
    width: 100%;
    max-width: 150px; /* 侧边图片较小 */
    max-height: 280px; /* 限制最大高度 */
    height: auto; /* 改为自适应高度 */
    object-fit: contain; /* 改为完整显示图片 */
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    transition: all 0.3s ease;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
    transform: scale(0.8); /* 默认更小 */
    opacity: 0.6; /* 非中心图片更透明 */
  }

  /* 中心图片样式 */
  .phone-image-carousel.active-image {
    transform: scale(1); /* 中心图片正常大小 */
    opacity: 1; /* 中心图片完全不透明 */
    max-width: 200px; /* 中心图片更大 */
    max-height: 320px; /* 限制中心图片最大高度 */
    height: auto; /* 改为自适应高度 */
    border-radius: 15px; /* 中心图片圆角更大 */
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2); /* 中心图片阴影更明显 */
    z-index: 1; /* 降低 z-index，避免影响导航栏 */
  }

  /* 轮播指示器 */
  .phone-carousel-indicators {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-top: 20px;
  }

  .phone-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.4);
    cursor: pointer;
    transition: all 0.3s ease;

    &.active {
      background: rgba(255, 255, 255, 0.9);
      transform: scale(1.2);
    }

    &:hover:not(.active) {
      background: rgba(255, 255, 255, 0.6);
    }
  }

  .download-buttons {
    margin-top: 30px;
    gap: 15px;
  }

  .download-btn {
    min-width: 160px;
  }

  /* 成为渠道伙伴区域移动端优化 */
  .partner-section {
    padding: 40px 0 120px 0;
    background-size: 100% auto;
    background-position: center top;
  }

  .partner-content {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .partner-title {
    font-size: 24px;
    margin: 25px 0 20px 0;
    text-align: center;
    line-height: 1.3;
    padding: 0 20px;
  }

  .partner-subtitle {
    font-size: 18px;
    margin: 0 0 20px 0;
    text-align: center;
    padding: 0 20px;
  }

  .partner-nav {
    padding-left: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;

    &::before {
      display: none;
    }
  }

  .partner-nav-item {
    background: rgba(255, 255, 255, 0.25);
    padding: 10px 16px;
    margin-bottom: 0;
    border-radius: 20px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;
    white-space: nowrap;
    min-width: auto;

    &.active {
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.9) 0%,
        rgba(255, 255, 255, 0.7) 100%
      );
      color: #333;
      margin-left: 0;
      border-radius: 20px;
      border: 1px solid rgba(255, 255, 255, 0.8);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transform: translateY(-1px);
    }

    &:hover:not(.active) {
      background: rgba(255, 255, 255, 0.35);
      transform: translateY(-1px);
    }
  }

  .partner-right {
    width: 100%;
    margin-top: 0;
    padding: 0 20px;
  }

  .partner-features {
    padding: 20px;
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(15px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }

  /* 特色功能项目移动端优化 */
  .feature-item {
    gap: 10px;
    margin-bottom: 18px;
    padding: 8px 0;
  }

  .feature-item-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  .feature-text {
    font-size: 13px;
    line-height: 1.6;
    color: #444;
    font-weight: 400;
  }

  .feature-custom-title {
    font-size: 15px;
    margin-bottom: 12px;
    color: #333;
    font-weight: 600;
  }

  .feature-card-title {
    font-size: 14px;
    margin-bottom: 6px;
    color: #333;
    font-weight: 600;
  }

  .feature-card-content {
    font-size: 12px;
    line-height: 1.6;
    color: #555;
    font-weight: 400;
  }

  .feature-item-type-1 {
    margin-bottom: 16px;
    padding-bottom: 16px;
  }

  .feature-item-type-2 {
    gap: 8px;
    margin-bottom: 10px;
  }

  .feature-item-type-2 .feature-text {
    font-size: 12px;
    line-height: 1.5;
  }

  /* 轮播图控制按钮移动端优化 */
  .carousel-controls {
    padding: 0 10px;
    top: 60%;
  }

  .carousel-btn {
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 18px;
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

    &:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.9);
      transform: scale(1.05);
    }
  }

  .btn-icon {
    width: 24px;
    height: 24px;
    filter: brightness(0.7);
  }

  .carousel-indicators {
    bottom: -100px;
    gap: 8px;
  }

  .indicator {
    width: 24px;
    height: 3px;
    border-radius: 2px;

    &.active {
      width: 32px;
      background: rgba(255, 255, 255, 0.9);
    }
  }

  .section-header {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
    text-align: center;
  }

  .section-title {
    font-size: 28px;
    justify-content: center;
  }

  .title-icon {
    width: 35px;
    height: 35px;
  }

  .search-box {
    width: 100%;
    max-width: none;
  }

  .search-input {
    font-size: 16px;
    padding: 16px 12px 16px 14px;
  }

  .search-btn {
    font-size: 14px;
    padding: 12px 20px;
  }

  .user-info-card {
    min-width: auto;
    width: 100%;
    padding: 15px;
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .user-details {
    flex-direction: column;
    gap: 10px;
  }

  .user-info-row {
    justify-content: center;
    gap: 15px;
    flex-wrap: wrap;
  }

  .recharge-tabs {
    width: 100%;
    justify-content: center;
  }

  .tab-btn {
    flex: 1;
    max-width: 150px;
  }

  .price-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
  }

  .price-card {
    padding: 15px 8px;
  }

  .price-badge {
    font-size: 16px;

    .price-badge-icon {
      width: 14px;
      height: 14px;
    }
  }

  .price-amount {
    font-size: 13px;
  }

  .hot-label {
    font-size: 9px;
    padding: 3px 8px;
    width: 60px;
    height: 20px;
    line-height: 14px;
  }

  .custom-amount-input-container {
    max-width: 100%;
    padding: 15px;
  }

  .custom-amount-icon {
    width: 28px;
    height: 28px;
  }

  .custom-amount-input {
    font-size: 16px;
  }

  .payment-section {
    padding: 25px 20px;
  }

  .payment-title {
    font-size: 18px;
  }

  .payment-btn {
    padding: 12px 25px;
    font-size: 15px;
  }

  .amount-row {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
  }

  .amount-info {
    text-align: center;
  }

  .amount-label {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .amount-description {
    font-size: 13px;
  }

  .confirm-btn {
    width: 100%;
    height: 50px;
    font-size: 16px;
    max-width: none;
  }

  .footer-content {
    flex-direction: column;
    text-align: center;
  }

  .footer-contact {
    justify-content: center;
    gap: 8px;

    span {
      font-size: 14px;
    }

    img {
      width: 60px;
      height: 60px;
    }
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 24px;
  }

  /* 充值弹窗超小屏幕适配 */
  ::v-deep .el-dialog {
    width: 95% !important;
    max-width: 340px !important;
    max-height: calc(100vh - 20px) !important;
    overflow-y: auto;
    margin: 0 !important;
  }

  ::v-deep .el-dialog__wrapper {
    padding: 10px !important;
    min-height: 100vh;
  }

  ::v-deep .el-dialog__header {
    padding: 12px 12px 8px;
  }

  ::v-deep .el-dialog__title {
    font-size: 15px;
    line-height: 1.3;
  }

  ::v-deep .el-dialog__body {
    padding: 8px 12px;
  }

  ::v-deep .el-dialog__footer {
    padding: 8px 12px 15px;
  }

  ::v-deep .dialog-footer {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  ::v-deep .dialog-footer .el-button {
    min-width: 80px;
    padding: 10px 16px;
    font-size: 13px;
    flex: 0 0 auto;
  }

  .qr-code-container {
    padding: 10px 0;
    min-height: 160px;
  }

  .qr-code-image {
    width: 160px;
    height: 160px;
    padding: 8px;
  }

  /* 超小屏幕轮播调整 */
  .mobile-phone-carousel {
    max-width: 300px;
    padding: 0 15px;
  }

  .phone-carousel-container {
    height: 280px; /* 超小屏幕减少容器高度 */
  }

  .phone-image-carousel {
    max-width: 120px; /* 超小屏幕侧边图片更小 */
    max-height: 220px; /* 限制超小屏幕侧边图片高度 */
    height: auto; /* 改为自适应高度 */
    border-radius: 10px;
  }

  .phone-image-carousel.active-image {
    max-width: 160px; /* 超小屏幕中心图片 */
    max-height: 250px; /* 限制超小屏幕中心图片高度 */
    height: auto; /* 改为自适应高度 */
    border-radius: 12px;
  }

  .phone-carousel-indicators {
    margin-top: 15px;
    gap: 6px;
  }

  .phone-indicator {
    width: 6px;
    height: 6px;
  }

  /* 超小屏幕渠道伙伴区域优化 */
  .partner-section {
    padding: 30px 0 100px 0;
    background-size: 120% auto;
  }

  .partner-title {
    font-size: 20px;
    margin: 20px 0 15px 0;
    padding: 0 15px;
  }

  .partner-subtitle {
    font-size: 16px;
    margin: 0 0 15px 0;
    padding: 0 15px;
  }

  .partner-content {
    gap: 20px;
  }

  .partner-nav {
    gap: 6px;
    padding: 0 15px;
  }

  .partner-nav-item {
    font-size: 12px;
    padding: 8px 12px;
    border-radius: 16px;

    &.active {
      border-radius: 16px;
    }
  }

  .partner-right {
    padding: 0 15px;
  }

  .partner-features {
    padding: 15px;
    border-radius: 12px;
  }

  /* 超小屏幕特色功能项目优化 */
  .feature-item {
    gap: 8px;
    margin-bottom: 12px;
    padding: 6px 0;
  }

  .feature-text {
    font-size: 11px;
    line-height: 1.5;
    color: #333;
  }

  .feature-custom-title {
    font-size: 13px;
    margin-bottom: 10px;
  }

  .feature-card-title {
    font-size: 12px;
    margin-bottom: 4px;
  }

  .feature-card-content {
    font-size: 11px;
    line-height: 1.5;
  }

  .feature-item-type-1 {
    margin-bottom: 12px;
    padding-bottom: 12px;
  }

  .feature-item-type-2 {
    gap: 6px;
    margin-bottom: 8px;
  }

  /* 超小屏幕轮播图控制优化 */
  .carousel-controls {
    padding: 0 5px;
    top: 65%;
  }

  .carousel-btn {
    width: 32px;
    height: 32px;
    border-radius: 16px;
  }

  .btn-icon {
    width: 20px;
    height: 20px;
  }

  .carousel-indicators {
    bottom: -80px;
    gap: 6px;
  }

  .indicator {
    width: 20px;
    height: 2px;

    &.active {
      width: 28px;
    }
  }

  .price-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 6px;
  }

  .price-card {
    padding: 12px 6px;
  }

  .price-badge {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .price-amount {
    font-size: 11px;
  }

  .hot-label {
    font-size: 8px;
    width: 50px;
    height: 18px;
    padding: 2px 6px;
    line-height: 14px;
  }

  .custom-amount-input-container {
    padding: 12px 15px;
  }

  .payment-section {
    padding: 20px 15px;
  }

  .payment-title {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .payment-btn {
    padding: 10px 20px;
    font-size: 14px;
  }

  .amount-label {
    font-size: 14px;
  }

  .amount-description {
    font-size: 12px;
  }

  .confirm-btn {
    height: 45px;
    font-size: 15px;
  }

  .download-buttons {
    flex-direction: column;
    align-items: center;
  }

  /* 充值弹窗移动端优化 */
  .qr-code-image {
    width: 180px;
    height: 180px;
  }

  /* Element UI Dialog 移动端适配 */
  ::v-deep .el-dialog {
    width: 90% !important;
    max-width: 400px !important;
    max-height: calc(100vh - 40px) !important;
    overflow-y: auto;
    margin: 0 !important;
  }

  ::v-deep .el-dialog__wrapper {
    padding: 15px !important;
    min-height: 100vh;
  }

  ::v-deep .el-dialog__header {
    padding: 15px 15px 10px;
  }

  ::v-deep .el-dialog__title {
    font-size: 16px;
  }

  /* 页脚480px以下适配 */
  .footer-contact {
    span {
      font-size: 12px;
    }

    img {
      width: 48px;
      height: 48px;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 10px 15px;
  }

  ::v-deep .el-dialog__footer {
    padding: 10px 15px 20px;
  }

  ::v-deep .dialog-footer {
    display: flex;
    justify-content: center;
    gap: 15px;
  }

  ::v-deep .dialog-footer .el-button {
    min-width: 90px;
    padding: 12px 20px;
    font-size: 14px;
    flex: 0 0 auto;
  }

  .qr-code-container {
    padding: 15px 0;
    min-height: 180px;
  }
}

/* 中等屏幕设备（平板）充值弹窗适配 */
@media (min-width: 481px) and (max-width: 1024px) {
  ::v-deep .el-dialog {
    width: 70% !important;
    max-width: 500px !important;
    margin: 0 !important;
  }

  ::v-deep .el-dialog__wrapper {
    padding: 20px !important;
  }

  ::v-deep .el-dialog__header {
    padding: 18px 18px 12px;
  }

  ::v-deep .el-dialog__title {
    font-size: 17px;
  }

  ::v-deep .el-dialog__body {
    padding: 12px 18px;
  }

  ::v-deep .el-dialog__footer {
    padding: 12px 18px 18px;
  }

  .qr-code-image {
    width: 190px;
    height: 190px;
  }
}

/* 协议弹窗样式 */
.agreement-dialog {
  ::v-deep .el-dialog {
    border-radius: 12px;
    margin: 0 !important;
  }

  ::v-deep .el-dialog__header {
    text-align: center;
    padding: 20px 20px 10px;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 0;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
    padding: 10px 20px 20px;
  }
}

.agreement-content {
  max-height: 60vh;
  overflow-y: auto;
  padding: 20px;
  line-height: 1.8;
  color: #333;
  font-size: 14px;

  /* 滚动条样式 */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.no-content {
  text-align: center;
  color: #999;
  padding: 40px 0;
  font-size: 14px;
}

/* 移动端适配 - 协议弹窗 */
@media (max-width: 768px) {
  ::v-deep .agreement-dialog .el-dialog {
    width: 95% !important;
    max-width: none !important;
    margin: 0 !important;
  }

  .agreement-content {
    max-height: 70vh;
    padding: 15px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  ::v-deep .agreement-dialog .el-dialog {
    width: 95% !important;
    max-width: none !important;
  }

  .agreement-content {
    max-height: 75vh;
    padding: 12px;
    font-size: 12px;
  }
}

/* 修复消息弹窗被导航栏遮挡的问题 */
::v-deep .el-message,
::v-deep .el-message-box,
::v-deep .el-notification,
/deep/ .el-message,
/deep/ .el-message-box,
/deep/ .el-notification {
  z-index: 99999 !important;
}

/* 全局消息组件层级修复 */
.el-message,
.el-message-box,
.el-notification,
.message,
.toast,
.alert {
  z-index: 99999 !important;
}
</style>
